import { Tag } from '@dev-spendesk/grapes';
import { useMemo } from 'react';

import { useTranslation } from 'src/core/common/hooks/useTranslation';

import {
  type Addon,
  type AddonSlug,
  addonToDisplayTranslationKeys,
} from '../../../../models';

type Props = {
  addons: Addon[];
};

export const CompanyPlanAddons = ({ addons }: Props) => {
  const { t } = useTranslation('global');
  const addonsToDisplay: { slug: AddonSlug; name: string }[] = useMemo(() => {
    return addons.flatMap((addon) => {
      if (addon.slug === 'supplementaryWallets') {
        if (addon.quantity > 0) {
          return {
            slug: addon.slug,
            name: t('billing.companyPlan.addons.supplementaryWallet', {
              count: addon.quantity,
            }),
          };
        }
        return [];
      }
      const key = addonToDisplayTranslationKeys[addon.slug];
      return key ? { slug: addon.slug, name: t(key) } : [];
    });
  }, [addons]);

  return addonsToDisplay.length > 0 ? (
    <ul className="flex list-none flex-wrap justify-start gap-8">
      {addonsToDisplay.map((addon) => (
        <li key={addon.slug}>
          <Tag variant="lemon">{addon.name}</Tag>
        </li>
      ))}
    </ul>
  ) : (
    <p>{t('billing.companyPlan.addons.emptyState')}</p>
  );
};
